import { render, staticRenderFns } from "./stockin_detail.vue?vue&type=template&id=b8b2150e&scoped=true"
import script from "./stockin_detail.vue?vue&type=script&lang=js"
export * from "./stockin_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b2150e",
  null
  
)

export default component.exports